import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { SegmentedSpinnerComponent } from './segmented-spinner.component';

@NgModule({
  declarations: [SegmentedSpinnerComponent],
  exports: [SegmentedSpinnerComponent],
  imports: [CommonModule, FlexLayoutModule, MatProgressSpinnerModule],
})
export class SegmentedSpinnerModule {}
